'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

var _PortalIdContainer = require('../globals/PortalIdContainer');

var _PortalIdContainer2 = _interopRequireDefault(_PortalIdContainer);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _locationOrigin = require('../utils/locationOrigin');

var _locationOrigin2 = _interopRequireDefault(_locationOrigin);

var _apiEnvironments = require('../constants/apiEnvironments');

var _apiEnvironments2 = _interopRequireDefault(_apiEnvironments);

var _appBasePath = require('../constants/appBasePath');

var _appBasePath2 = _interopRequireDefault(_appBasePath);

var _envInfo = require('../constants/envInfo');

var _makeLinkWithQueryParams = require('../utils/makeLinkWithQueryParams');

var _makeLinkWithQueryParams2 = _interopRequireDefault(_makeLinkWithQueryParams);

var _params = require('hub-http/helpers/params');

var _pick = require('hs-lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _isFunnel = require('./isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _shouldPrependPortalOnStep = require('./shouldPrependPortalOnStep');

var _shouldPrependPortalOnStep2 = _interopRequireDefault(_shouldPrependPortalOnStep);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _getRequestedStepFromPath = require('./getRequestedStepFromPath');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('utils/links');

function loginQuery(next, query, email) {
  if (next) {
    query = '' + query + (query ? '&' : '?') + 'loginRedirectUrl=' + encodeURIComponent(next);
  }

  if (email) {
    query = '' + query + (query ? '&' : '?') + 'email=' + encodeURIComponent(email);
  }
  return query;
}

var links = {
  baseSignup: function baseSignup() {
    var includeStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var url = new _Url2.default(window.location);
    url.update({
      pathname: window.location.pathname.split('/').slice(0, includeStep ? 5 : 3).join('/')
    });
    return url;
  },
  signup: function signup() {
    var baseSignup = this.baseSignup();
    return '' + baseSignup.pathname + baseSignup.search;
  },
  signupFlow: function signupFlow(_signupFlow) {
    var includeStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var baseSignupUrl = this.baseSignup(includeStep);
    var step = (0, _getRequestedStepFromPath.getRequestedStepFromPath)();
    return '' + _appBasePath2.default + _signupFlow + (includeStep ? '/step/' + step : '') + baseSignupUrl.search;
  },
  step: function step(_step) {
    var additionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var baseSignup = this.baseSignup();
    var stepLink = '/step/' + _step;
    var portalId = _PortalIdContainer2.default.get();
    //some step, like JOIN_HUBSPOT_EMPLOYEE have the portal ID in the url
    //this is particularly useful on auth failure, building login redirect url containing portal id and correctly tracking the
    //signup completed on the way back to Signup
    var nextLink = '' + baseSignup.pathname + ((0, _shouldPrependPortalOnStep2.default)(_step) ? '/' + portalId : '') + stepLink;
    return (0, _makeLinkWithQueryParams2.default)(nextLink, Object.assign(_QueryParamsContainer2.default.getJS(), additionalParams));
  },
  flowlessStep: function flowlessStep(step) {
    return _appBasePath2.default + 'step/' + step;
  },
  privacy: function privacy() {
    return 'https://legal.hubspot.com/privacy-policy';
  },
  customerTerms: function customerTerms() {
    return 'https://legal.hubspot.com/terms-of-service';
  },
  gdpr: function gdpr() {
    return 'https://www.hubspot.com/data-privacy/gdpr';
  },
  shortlink: function shortlink() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return _locationOrigin2.default + '/l/' + path;
  },
  productSetup: function productSetup() {
    var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var portalId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _PortalIdContainer2.default.get();

    if (!portalId) {
      return _locationOrigin2.default + '/configuration/';
    }

    return _locationOrigin2.default + '/configuration/' + portalId + '/' + product;
  },
  crmStartPage: function crmStartPage() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId + '/start';
  },
  startupApplication: function startupApplication() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/hsfx-programs/' + portalId;
  },


  // ---------------------------------------------------------------------------
  // utilities

  login: function login(next, email) {
    var query = '';
    query = loginQuery(next, query, email);
    return 'https://' + _apiEnvironments2.default.HUBSPOT_LOGIN + query;
  },
  loginFbCrm: function loginFbCrm(next, email) {
    var query = '?allowFbSignup=true';
    query = loginQuery(next, query, email);
    return 'https://' + _apiEnvironments2.default.HUBSPOT_LOGIN + query;
  },
  portalUpgrades: function portalUpgrades() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/upgrades/' + portalId;
  },
  getLoginRedirectUrl: function getLoginRedirectUrl(user) {
    var redirectUrl = void 0;

    if (_isFunnel2.default.legacyTrial()) {
      _QueryParamsContainer2.default.setParam('email', user.get('email'));
      _QueryParamsContainer2.default.setParam('website', user.get('domain'));

      var baseUrl = window.location.href.split('?')[0];
      redirectUrl = (0, _makeLinkWithQueryParams2.default)(baseUrl);
    } else if (_isFunnel2.default.partnerClient()) {
      _QueryParamsContainer2.default.setParam('clientEmail', user.get('clientEmail'));
      _QueryParamsContainer2.default.setParam('domain', user.get('domain'));

      var _baseUrl = window.location.href.split('?')[0];
      redirectUrl = (0, _makeLinkWithQueryParams2.default)(_baseUrl);
    } else if (_isFunnel2.default.checkout()) {
      redirectUrl = _QueryParamsContainer2.default.get('loginRedirectUrl');
    } else {
      redirectUrl = window.location.href;
    }

    return redirectUrl;
  },


  // ---------------------------------------------------------------------------
  // features

  salesDashboard: function salesDashboard() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/reports-dashboard/' + portalId + '/sales';
  },


  // generic default
  dashboard: function dashboard() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/dashboard/' + portalId + '/';
  },
  marketingFree: function marketingFree() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/marketing/' + portalId + '/';
  },
  marketingFreeContacts: function marketingFreeContacts() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/marketing/' + portalId + '/contacts';
  },
  marketingFreeLeadFlows: function marketingFreeLeadFlows() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/lead-flows/' + portalId + '/';
  },
  marketingFreeForms: function marketingFreeForms() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/forms/' + portalId + '/';
  },
  marketingFreeEmail: function marketingFreeEmail() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    // enroll parameter is for enrolling in the Getting Started onboarding page.
    return _locationOrigin2.default + '/email/' + portalId + '?enroll=true';
  },
  marketingAds: function marketingAds() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/ads/' + portalId + '/onboarding?adsCampaign=true';
  },
  developers: function developers() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/developers/' + portalId + '/';
  },


  // generic sales default.
  // Do not add more functions for intents on this url, just add the mapping in
  // static/js/core/constants/productIntentLinks.js file with a new alias
  salesDefault: function salesDefault() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId;
  },
  salesO365: function salesO365() {
    return _locationOrigin2.default + '/office365app/signup-success';
  },
  salesVsto: function salesVsto() {
    return _locationOrigin2.default + '/sales-client-iframes/vsto/onboarding/signup';
  },
  crmContacts: function crmContacts() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId + '/contacts';
  },
  crmCompanies: function crmCompanies() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId + '/companies';
  },
  crmDeals: function crmDeals() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId + '/deals';
  },
  crmTasks: function crmTasks() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId + '/tasks';
  },
  conversations: function conversations() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/live-messages/' + portalId + '/';
  },
  salesNotifications: function salesNotifications() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/sales-stream/' + portalId + '/all';
  },
  salesTemplates: function salesTemplates() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/templates/' + portalId + '/';
  },
  salesSequences: function salesSequences() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/sequences/' + portalId;
  },
  salesDocuments: function salesDocuments() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/presentations/' + portalId;
  },
  salesProspects: function salesProspects() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/contacts/' + portalId + '/visits';
  },
  salesMeetings: function salesMeetings() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/meetings/' + portalId;
  },
  salesPro: function salesPro() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/browse/' + portalId + '/compare/sales';
  },


  // service dash
  serviceDashboard: function serviceDashboard() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/reports-dashboard/' + portalId + '/service';
  },
  academy: function academy() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/learning-center/' + portalId;
  },
  academySalesSoftwareCert: function academySalesSoftwareCert() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/learning-center/' + portalId + '/course/9/0';
  },
  academyAttractingWithFbLesson: function academyAttractingWithFbLesson() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/learning-center/' + portalId + '/lessons/22/';
  },
  designManager: function designManager() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/design-manager/' + portalId + '/welcome';
  },
  partnerClientDashboard: function partnerClientDashboard() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/dashboard/' + portalId + '/';
  },
  learningCenter: function learningCenter() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();
    var intentParamsMap = arguments[1];

    if (intentParamsMap.has('lesson')) {
      var lessonId = intentParamsMap.get('lesson');
      return lessonId ? _locationOrigin2.default + '/learning-center/' + portalId + '/lessons/' + lessonId + '/' : _locationOrigin2.default + '/learning-center/' + portalId + '/lessons';
    } else if (intentParamsMap.has('track')) {
      var trackId = intentParamsMap.get('track');
      return trackId ? _locationOrigin2.default + '/learning-center/' + portalId + '/tracks/' + trackId + '/' : _locationOrigin2.default + '/learning-center/' + portalId + '/tracks';
    }
    return _locationOrigin2.default + '/learning-center/' + portalId + '/';
  },
  leadAds: function leadAds() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/lead-ads/' + portalId;
  },
  fbCrm: function fbCrm() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    return _locationOrigin2.default + '/facebook/ads/' + portalId + '/';
  },
  growthhubInbound: function growthhubInbound(portalId, intentParamsMap) {
    var inboundUserId = intentParamsMap.get('inbound-user-id');
    return _locationOrigin2.default + '/growthhub/inbound/' + inboundUserId + '/signed-in';
  },
  codeFunnelAnatomy: function codeFunnelAnatomy() {
    return 'https://offers.hubspot.com/thank-you/anatomy-of-a-five-star-email-b';
  },
  codeFunnelSeo: function codeFunnelSeo() {
    return 'https://offers.hubspot.com/thank-you/seo-myths-b';
  },
  codeFunnelInfographics: function codeFunnelInfographics() {
    return 'https://offers.hubspot.com/thank-you/generate-leads-with-infographics-b';
  },
  codeFunnelTemplates: function codeFunnelTemplates() {
    return 'https://offers.hubspot.com/thank-you/call-to-action-templates-b';
  },
  codeFunnelExcel: function codeFunnelExcel() {
    return 'https://offers.hubspot.com/thank-you/how-to-use-excel-b';
  },
  codeFunnelData: function codeFunnelData() {
    return 'https://offers.hubspot.com/thank-you/data-visualization-guide-b';
  },
  connectIntegration: function connectIntegration() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();
    var intentParamsMap = arguments[1];

    var integration = intentParamsMap.get('integration');
    var validOptionalIntegrationKeys = ['code', 'redirect_uri', 'connectState', 'companyName', 'domain', 'email', 'firstName', 'lastName'];
    var queryObject = _pick2.default.apply(undefined, [intentParamsMap.toJS()].concat(validOptionalIntegrationKeys));
    var queryString = (0, _params.stringify)(queryObject);
    return _locationOrigin2.default + '/integrations-beta/' + portalId + '/all-integrations?connect=' + integration + '&' + queryString;
  },
  trial: function trial() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();
    var intentParamsMap = arguments[1];

    var baseUrl = _locationOrigin2.default + '/trial/' + portalId;
    if (!intentParamsMap) {
      return baseUrl;
    }
    return baseUrl + '?' + (0, _params.stringify)(intentParamsMap.toJS()) + '&via=trial-signup';
  },
  purchase: function purchase() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();
    var intentParamsMap = arguments[1];

    var bundledOffer = intentParamsMap.get('bundledOffer');

    var link = void 0;
    if (bundledOffer) {
      link = _locationOrigin2.default + '/purchase/' + portalId + '/bundled-offer/' + bundledOffer;
    } else {
      link = _locationOrigin2.default + '/purchase/' + portalId + '/';
    }

    return link;
  },
  growthHub: function growthHub(userId) {
    if (!userId) {
      LOG.warn('Missing user id for growth hub signup redirect');
      return 'https://growth.org';
    }
    var envSuffix = _envInfo.isProd ? '' : 'qa';
    return 'https://growth' + envSuffix + '.org/users/' + userId;
  },
  wordpressGettingStarted: function wordpressGettingStarted() {
    var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PortalIdContainer2.default.get();

    var baseUrl = _QueryParamsContainer2.default.get('redirectBaseUrl') || _locationOrigin2.default;
    return baseUrl + '/hubspot-plugin/' + portalId + '/connect';
  },
  getWordpressLogout: function getWordpressLogout() {
    var redirect = '?redirectUrl=' + encodeURIComponent(_locationOrigin2.default + '/signup/wordpress' + location.search);

    return 'https://api.hubspot' + _envInfo.domainSuffix + '.com/login-api/v1/logout' + redirect;
  },
  gmail: function gmail() {
    return 'https://mail.google.com/mail/';
  },
  yahoo: function yahoo() {
    return 'https://mail.yahoo.com';
  },
  notFound: function notFound() {
    // TODO: Is there a reliable way to link them to the hubspot "not found something broke" page?
    return 'https://www.hubspot.com/products/marketing/a-clearly-broken-link';
  }
};

exports.default = links;
module.exports = exports['default'];